
import React from 'react';
import '../App.css';
import {
    Row,
    Col
} from 'bootstrap-4-react';
import compressor from '../compressor.jpg'

function EquipmentRow() {



    return (
        <Row id="equipmentRow" className={'programItem'}>
            <Col col="md-4">
                <h2 className="subtitle rowSubtitle">Какое оборудование и отделочные материалы использовать</h2>
                <p>Многолетний опыт механизированного нанесения декоративных покрытий позволил нам сформировать оптимальный перечень оборудования и производить отделочные материалы, максимально подходящие для механизированного нанесения</p>

            </Col>
            <Col col="md-8">
                <img src={compressor} alt={'compressor'} width={'100%'}/>
            </Col>
        </Row>


    );
}

export default EquipmentRow;
